// removed by extract-text-webpack-plugin
module.exports = {"xl":"sizeM__xl___3ksqi breakPointM-marginRight-xl","l":"sizeM__l___2_b6L breakPointM-marginRight-l","m":"sizeM__m___WK1_m breakPointM-marginRight-m","s":"sizeM__s___9uV8P breakPointM-marginRight-s","xs":"sizeM__xs___2yWLb breakPointM-marginRight-xs","xxs":"sizeM__xxs___3K5iM breakPointM-marginRight-xxs"};


//////////////////
// WEBPACK FOOTER
// ./packages/marvel-ui-grid/InlineGrid/style/sizeM.css
// module id = 15
// module chunks = 0 1 2 3 6